import Button from '@ui/button/Button';
import analytics from '@utils/analytics';
import classNames from 'classnames';
import React from 'react';
import { useTranslation } from 'react-i18next';
const ContactChatBox = (props) => {
    const { t } = useTranslation();
    const buttonEnabled = window.chatenabled && window.sprChat;
    if (props.type == 'footer') {
        return (React.createElement("div", null,
            React.createElement(Button, { type: "button", disabled: !buttonEnabled, cls: ['button--tertiary'], className: classNames('chat chat-button'), onClick: () => {
                    window.sprChat && window.sprChat('open');
                    analytics.contactUsOne('live chat');
                    if (props.onClickCallback) {
                        props.onClickCallback();
                    }
                } }, t('footer.clientservice.startchat'))));
    }
    return (React.createElement("div", { className: "row link-box line" },
        React.createElement("div", { className: "col-lg-8 col-md-6 col-sm-7 col-xs-12" },
            React.createElement("h3", { className: "link-box__title" }, t('clientservice.livechat')),
            React.createElement("p", { className: "col-sm-10" },
                t('clientservice.livechatintro'),
                " ")),
        React.createElement("div", { className: "col-lg-4 col-md-6 col-sm-5 col-xs-12 " },
            React.createElement(Button, { type: "button", disabled: !buttonEnabled, cls: ['button--secondary'], className: classNames('link-box__button chat-button'), onClick: () => {
                    window.sprChat && window.sprChat('open');
                    analytics.contactUsOne('live chat');
                    if (props.onClickCallback) {
                        props.onClickCallback();
                    }
                } }, t('clientservice.startchat')))));
};
export default ContactChatBox;
